import React, { ButtonHTMLAttributes } from 'react';
import CustomIcon, { IconName } from './CustomIcon';
import styles from './IconButton/IconButton.module.scss';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  iconName: IconName;
  size?: 'small' | 'medium' | 'large';
  variant?: 'primary' | 'secondary' | 'tertiary';
  iconSize?: number;
  iconColor?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  iconName,
  size = 'medium',
  variant = 'primary',
  iconSize,
  iconColor,
  className = '',
  ...props
}) => {
  // Determinar el tamaño del icono basado en el tamaño del botón
  const getIconSize = () => {
    if (iconSize) return iconSize;

    switch (size) {
      case 'small':
        return 16;
      case 'large':
        return 24;
      default:
        return 20;
    }
  };

  const buttonClasses = [
    styles['icon-button'],
    styles[`icon-button--${size}`],
    styles[`icon-button--${variant}`],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={buttonClasses} {...props}>
      <CustomIcon name={iconName} width={getIconSize()} height={getIconSize()} color={iconColor} />
    </button>
  );
};

export default IconButton;
